export enum CourseStatusEnum {
    DRAFT = 'draft',
    PUBLISHED = 'published',
    STARTED = 'started',
    CLOSED = 'closed',
}